<template>
  <div class="Projects grid">
    <h1>{{ text }}</h1>
    <div class="grid-auto-md">
      <AboutThumb v-for="project in page.projects" :item="project" :key="project.url"></AboutThumb>
    </div>
  </div>
</template>

<script>
import widont from 'widont'
import { mixin } from '@/lib/content-state'

import AboutThumb from '@/components/AboutThumb'

export default {
  name: 'Projects',
  mixins: [ mixin ],
  components: { AboutThumb },
  computed: {
    text () {
      return widont(this.page.content)
    }
  }
}
</script>

<style scoped>
h1 {
  grid-column: 1 / -1;
  font: var(--large);
  text-align: center;
  margin: 2rem auto 3rem;
  max-width: 80rem;
}

h1 + .AboutThumb {
  grid-column: 1 / span 3;
}
</style>